import React from 'react';

const AffiliateTracking = () => {
  return (
    <div className="w-full bg-white shadow p-4 md:p-6 rounded-md">
      <h3 className="text-lg font-semibold mb-4">Affiliate Tracking</h3>
      <form className="space-y-6">
        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700">
            Tracking Method <span className="text-red-500">*</span>
          </label>
          <select className="w-full border border-orange-300 rounded-md p-2 mt-1 focus:border-orange-500 focus:ring-orange-500">
            <option>Pixel Tracking</option>
            <option>Postback URL</option>
            <option>Server to Server</option>
          </select>
        </div>

        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700">
            Tracking Domain
          </label>
          <input
            type="url"
            className="w-full border border-orange-300 rounded-md p-2 mt-1 focus:border-orange-500 focus:ring-orange-500"
            placeholder="https://track.example.com"
          />
        </div>

        <div className="text-right">
          <button
            type="submit"
            className="bg-orange-500 text-white px-4 py-2 rounded-md hover:bg-orange-600 transition duration-300"
          >
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default AffiliateTracking; 